var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.7 14.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #9c9c9c;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.64,2.35v11.34c0,.36-.29.65-.65.65H2.77c-.36,0-.65-.29-.65-.65V2.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.66,2.04V.58s-.16-.08-.35-.08h-3.86c-.19,0-.35.04-.35.08v1.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 2.25,
    x2: 12.2,
    y2: 2.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.95,
    y1: 5.33,
    x2: 3.95,
    y2: 11.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.38,
    y1: 5.33,
    x2: 6.38,
    y2: 11.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.81,
    y1: 5.33,
    x2: 8.81,
    y2: 11.36
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7cb68627c46b2d53fef81f6138f86826.svg";
export { ForwardRef as ReactComponent };